import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import franchiseAdminAPI from "../../../api/franchiseAdminAPI";
import Pagination from "../../../components/Pagination";

const Franchise = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({
    organization: "",
    location: "",
  });
  const [franchises, setFranchises] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const email = Cookies.get("userEmail");

  useEffect(() => {
    if (email) {
      fetchFranchises();
    }
  }, [page, pageSize]);

  useEffect(() => {
    if (email) {
      franchiseAdminAPI
        .getFranchiseDetailsByEmail(email)
        .then((res) => {
          setData({
            organization: res.data.organization,
            location: res.data.location,
          });
        })
        .catch((err) => {
          console.error("Error fetching franchise details:", err);
        });
    }
  }, []);

  const fetchFranchises = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await franchiseAdminAPI.getFranchisesByEmail(
        email,
        page,
        pageSize,
      );
      setFranchises(response.data.content || []);
      setTotalPages(response.data.totalPages || 0);
    } catch (error) {
      console.error("Error fetching franchises:", error);
      setFranchises([]);
      setTotalPages(0);
      setError("Failed to load franchises. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0);
  };

  const handlePageClick = (data) => {
    const selectedPage = Math.max(0, Math.min(data.selected, totalPages - 1));
    setPage(selectedPage);
    localStorage.setItem("franchise-level1", selectedPage);
  };

  const handleAddFranchise = () => {
    navigate("/franchise-dashboard/franchises/add");
  }
  return (
    <div>
      <h1>
        <strong>
          {data.organization} - {data.location} franchises
        </strong>
      </h1>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <p>This is the Franchises page</p>
        <Button variant="primary" onClick={handleAddFranchise}>
          Add Franchise
        </Button>
      </div>
      <Table striped bordered hover mb-3>
        <thead>
          <tr>
            <th>Manage By</th>
            <th>Franchise L2</th>
            <th>Location</th>
            <th>Created At</th>
          </tr>
        </thead>
        <tbody>
          {franchises.map((franchise, index) => (
            <tr key={franchise.id ?? index}>
              <td>{franchise.email}</td>
              <td>{franchise.organization}</td>
              <td>{franchise.location}</td>
              <td>{franchise.createdAt}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div style={{ marginTop: "auto" }}>
        {franchises.length > 0 && totalPages > 0 && (
          <Pagination
            page={page}
            pageSize={pageSize}
            totalPages={totalPages}
            handlePageSizeChange={handlePageSizeChange}
            handlePageClick={handlePageClick}
          />
        )}
      </div>
    </div>
  );
};

export default Franchise;
